import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { AlbumState } from "../../Slice/Dashboard/AlbumSlice";
import {
  ActivateGuestFlow,
  getAllRedeemUserAPI,
  getLIkedImagesAPI,
  lockAlbum,
  removeRedeemUserAPI,
  toggleMediaPaymentAPI,
  unlockAlbum,
} from "../../ApiCalls/Dashboard/AlbumAPI";
import { RedeemUsers, User } from "../../../Data/user.dto";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../components/atoms/Utlis/Toast";
import { LikedImageType } from "../../../Data/album.dto";
export const AlbumOptionReducer = (
  builder: ActionReducerMapBuilder<AlbumState>
) => {
  builder
    .addCase(lockAlbum.pending, (state) => {
      state.loading = true;
    })
    .addCase(lockAlbum.fulfilled, (state, action: any) => {
      state.loading = false;
      state.isUpdate = true;
      const { project_id, lock_type } = action.meta.arg;
      if (lock_type === "activate_watermark" || lock_type === "disable_watermark") {
        const active = lock_type === "activate_watermark";
        if (state.currentAlbum && state.currentAlbum.id === project_id) {
          state.currentAlbum.activate_watermark = active;
        }
        state.albums.forEach((album) => {
          if (album.id === project_id) {
            album.activate_watermark = active;
          }
        });
      } else if (lock_type === "hide" || lock_type === "unhide") {
        const hide = lock_type === "hide";
        if (state.currentAlbum && state.currentAlbum.id === project_id) {
          state.currentAlbum.is_hide = hide;
        }
        state.albums.forEach((album) => {
          if (album.id === project_id) {
            album.is_hide = hide;
          }
        });
      } else if (lock_type === "lock") {
        if (state.currentAlbum && state.currentAlbum.id === project_id) {
          state.currentAlbum.is_locked = true;
        }
        state.albums.forEach((album) => {
          if (album.id === project_id) {
            album.is_locked = true;
          }
        });
      }
      showSuccessToast("Album status updated.");
    })
    .addCase(lockAlbum.rejected, (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.isError = true;
      state.isUpdate = false;
      if (action.payload && action.payload.message) {
        showErrorToast(action.payload.message);
      } else {
        console.log(action.payload);
      }
    })
    .addCase(unlockAlbum.pending, (state) => {
      state.loading = true;
      state.folderLoading = true;
    })
    .addCase(unlockAlbum.fulfilled, (state, action: any) => {
      state.loading = false;
      state.isUpdate = true;
      state.folderLoading = false;
      const project_id = action.meta.arg;
      if (state.currentAlbum && state.currentAlbum.id === project_id) {
        state.currentAlbum.is_locked = false;
      }
      state.albums.forEach((album) => {
        if (album.id === project_id) {
          album.is_locked = false;
        }
      });
    })
    .addCase(unlockAlbum.rejected, (state, action: PayloadAction<any>) => {
      state.folderLoading = false;
      state.loading = false;
      state.isError = true;
      state.isUpdate = false;
      // console.log(action.payload);
      if (action.payload && action.payload.message) {
        showErrorToast(action.payload.message);
      } else {
        console.log(action.payload);
      }
    })
    .addCase(toggleMediaPaymentAPI.pending, (state) => {
      state.loading = true;
      state.folderLoading = true;
    })
    .addCase(
      toggleMediaPaymentAPI.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.folderLoading = false;
        if (
          action.payload &&
          (action.payload.status === false ||
            action.payload.success === false ||
            action.payload.error)
        ) {
          state.isError = true;
          state.isUpdate = false;
          const errorMsg =
            typeof action.payload === "string"
              ? action.payload
              : action.payload.message ||
                action.payload.error ||
                action.payload.detail ||
                "Failed to update media payment flow.";
          showErrorToast(errorMsg);
        } else {
          state.isUpdate = true;
          const perImage = action.payload?.pricing_breakdown?.per_image;
          const baseMsg =
            action.payload?.message || "Media payment flow status updated.";
          showSuccessToast(
            perImage
              ? `${baseMsg} Customer pays ₹${perImage.customer_pays}, you receive ₹${perImage.studio_receives} per image.`
              : baseMsg
          );
        }
      }
    )
    .addCase(
      toggleMediaPaymentAPI.rejected,
      (state, action: PayloadAction<any>) => {
        state.folderLoading = false;
        state.loading = false;
        state.isError = true;
        state.isUpdate = false;
        const errorMsg =
          typeof action.payload === "string"
            ? action.payload
            : action.payload?.message ||
              action.payload?.error ||
              action.payload?.detail ||
              "Failed to update media payment flow.";
        showErrorToast(errorMsg);
      }
    )
    .addCase(getAllRedeemUserAPI.pending, (state) => {
      state.loading = true;
      state.isError = false;
    })
    .addCase(
      getAllRedeemUserAPI.fulfilled,
      (state, action: PayloadAction<RedeemUsers[]>) => {
        state.loading = false;
        state.redeemUsers = action.payload;
        state.isRedeemUserUpdates = false;
      }
    )
    .addCase(
      getAllRedeemUserAPI.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.isError = true;
        state.redeemUsers = [];

        // console.log(action.payload);
        if (action.payload && action.payload.message) {
          showErrorToast(action.payload.message);
        } else {
          console.log(action.payload);
        }
      }
    )
    .addCase(removeRedeemUserAPI.pending, (state) => {
      state.loading = true;
      state.isError = false;
    })
    .addCase(
      removeRedeemUserAPI.fulfilled,
      (state, action: PayloadAction<User[]>) => {
        state.loading = false;
        state.isRedeemUserUpdates = true;
        // state.redeemUsers = action.payload;
      }
    )
    .addCase(
      removeRedeemUserAPI.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.isError = true;
        // console.log(action.payload);
        if (action.payload && action.payload.message) {
          showErrorToast(action.payload.message);
        } else {
          console.log(action.payload);
        }
      }
    )
    .addCase(getLIkedImagesAPI.pending, (state) => {
      state.loading = true;
      state.isError = false;
    })
    .addCase(
      getLIkedImagesAPI.fulfilled,
      (
        state,
        action: PayloadAction<{
          count: number;
          results: {
            project: string;
            media_id: LikedImageType;
          }[];
        }>
      ) => {
        state.loading = false;
        if (action.payload) {
          let { count, results } = action.payload;
          if (count > 0) {
            let project_id = results[0].media_id.project_id;
            if (state.currentAlbum && state.currentAlbum.id === project_id) {
              state.currentAlbum.liked_images = [];
              for (let i = 0; i < results.length; i++) {
                state.currentAlbum.liked_images.push(results[i].media_id);
              }
            }
            for (let i = 0; i < state.albums.length; i++) {
              if (state.albums[i].id === state.currentAlbum?.id) {
                state.albums[i].liked_images = state.currentAlbum.liked_images;
              }
            }
          } else {
            if (state.currentAlbum) state.currentAlbum.liked_images = [];
          }
        } else {
          if (state.currentAlbum) state.currentAlbum.liked_images = [];
        }
        // state.redeemUsers = action.payload;
      }
    )
    .addCase(
      getLIkedImagesAPI.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.isError = true;

        // console.log(action.payload);
        if (action.payload && action.payload.message) {
          showErrorToast(action.payload.message);
        } else {
          console.log(action.payload);
        }
      }
    )
    .addCase(ActivateGuestFlow.pending, (state) => {
      state.loading = true;
      state.folderLoading = true;
    })
    .addCase(
      ActivateGuestFlow.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.isUpdate = true;
        state.folderLoading = false;
        showSuccessToast("Guest flow status updated.");
      }
    )
    .addCase(
      ActivateGuestFlow.rejected,
      (state, action: PayloadAction<any>) => {
        state.folderLoading = false;
        state.loading = false;
        state.isError = true;
        state.isUpdate = false;
        // console.log(action.payload);
        if (action.payload && action.payload.message) {
          showErrorToast(action.payload.message);
        } else {
          console.log(action.payload);
        }
      }
    );
};
